import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {

    applicationForm!: FormGroup;
    selectedFile: File | null = null;
    selectedImage: string | null = null;

    cultureValues = [
        {
            icon: 'lightbulb',
            title: 'Innovation',
            description: 'We encourage bold ideas and creative problem-solving to transform education.'
        },
        {
            icon: 'visibility',
            title: 'Transparency',
            description: 'Open communication and honest relationships with clients and team members.'
        },
        {
            icon: 'groups',
            title: 'Teamwork',
            description: 'Collaborative environment where every voice matters and contributions are valued.'
        },
        {
            icon: 'school',
            title: 'Continuous Learning',
            description: 'We believe in growing together through knowledge sharing and skill development.'
        },
        {
            icon: 'star',
            title: 'Quality',
            description: 'Commitment to excellence in every product, service, and customer interaction.'
        },
        {
            icon: 'favorite',
            title: 'Customer-First',
            description: 'Your success is our success. We put educators and students at the heart of everything.'
        }
    ];

    constructor(private fb: FormBuilder) { }

    ngOnInit(): void {
        this.applicationForm = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
            role: ['', Validators.required],
            message: ['', [Validators.required, Validators.minLength(10)]]
        });
    }

    onFileSelected(event: any): void {
        const file = event.target.files[0];
        if (file) {
            // Validate file type (only PDF and DOC files)
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (allowedTypes.includes(file.type)) {
                this.selectedFile = file;
            } else {
                alert('Please upload only PDF or DOC files');
                event.target.value = '';
            }
        }
    }

    onSubmit(): void {
        if (this.applicationForm.valid && this.selectedFile) {
            console.log('Form Data:', this.applicationForm.value);
            console.log('Resume File:', this.selectedFile);

            // Here you would typically send the data to your backend
            alert('Application submitted successfully! We will get back to you soon.');

            // Reset form
            this.applicationForm.reset();
            this.selectedFile = null;
        } else {
            alert('Please fill all required fields and upload your resume');
        }
    }

    openImageModal(imageUrl: string): void {
        this.selectedImage = imageUrl;
    }

    closeImageModal(): void {
        this.selectedImage = null;
    }
}
